
<i v-bind="$attrs" :class="`uil uil-${icon}`" :style="`font-size: ${size}px`"></i>
